// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"94ed1533","453":"f181431d","514":"7db0c185","939":"d41c0b9e"}[chunkId] + ".chunk.js";
};